export type UserLocation = {
  latitude: number | null;
  longitude: number | null;
};

export const refreshUserLocation = (
  latitude: number | null,
  longitude: number | null
): Promise<UserLocation> => {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) {
      resolve({ latitude, longitude });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => {
        resolve({ latitude, longitude });
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 60_000,
      }
    );
  });
};
